import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ScKryptoService } from './ScKryptoService';
// Auth headers (Authorization, Content-Type, ngrok-skip-browser-warning) are
// injected automatically by ApiHeadersInterceptor — no getHeaders() needed here.
import Swal from 'sweetalert2';
import { EnvService } from './env/env.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  live_Url:any= "https://smartcover-api.herokuapp.com//smartCover/api/";
  baseURL:any = "https://smartcover-api.herokuapp.com//smartCover/api/agents/";
  baseURL2:any = "https://smartcover-api.herokuapp.com//smartCover/api/";
  VanTestURL="https://smartcover-vang-api.herokuapp.com/smartCover/api";
  

  // activeBaseURL="https://ecomputing.vanguardassurance.com/smartCover/api";
  // activeBaseURL="https://ecomputing.vanguardassurance.com:8085/smartCover/testapi";
  // activeBaseURL="https://da14-197-251-216-202.ngrok.io/smartCover/testapi";
 
  
  activeUrl="";
  agent_code="";

  swalAlart=Swal;

  googleGeoLocURL = 'https://www.googleapis.com/geolocation/v1/geolocate'
  googleKey = 'AIzaSyBIBE7Ammv9lTPMzd-pGJUZK2PaYZQro0I'
  googleGeoCodeURL = 'https://maps.googleapis.com/maps/api/geocode/json'





  notifyBucket: any = "/topics/com.ecl.smartcoveragent";
  notifyUrl: any = 'https://fcm.googleapis.com/fcm/send';
  MailSender_Url:any= "https://smartcover-api-dev.azurewebsites.net/smartCover/api";
  FlutterPayURL: any = 'https://api.flutterwave.com/v3/payments';


  isLoggedInStatus:any;


   // FlutterWave has its own API key — not a Hollard JWT, kept explicitly.
   // The interceptor skip list contains 'flutterwave.com' so it won't be overridden.
   private flutterOptions = {
    headers: new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', 'Bearer FLWSECK_TEST-f245ad1f5b6ff6b57e0d6c2a2276df8f-X')
   };

   // FCM push notification key — Google service, not a Hollard JWT.
   // The interceptor skip list contains 'fcm.googleapis.com'.
   private smsoptions = {
    headers: new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', 'key=AIzaSyBlTd4JoSMbrs8W5eeRESJ5_TMFIHrgnBw')
   };


  constructor(private http: HttpClient,private krypto: ScKryptoService,  public env: EnvService, ) {
    console.log("env.apiUrl --->>> " + this.env.apiUrl)
    
    this.activeUrl = this.env.apiUrl ;
    this.agent_code = this.currentUser()?this.currentUser().code:'';

  }

  get isLoggedIn(){
    this.isLoggedInStatus = localStorage.isLoggedInStatus
    if(!this.isLoggedInStatus){
      return false
    } else {
      return true
    }
  }

  logoutUser(){
    //localStorage.removeItem("appuser");
    localStorage.clear();
  }

  currentUser(user_data?: any,transform: boolean=false){

    if(user_data){
      if(transform)
      user_data=this.krypto.transFormLoginResponse(user_data);

      localStorage.setItem('appuser',this.krypto.encrypt(JSON.stringify(user_data)));
    }
    else{
      user_data=localStorage.getItem('appuser');
      try {
        user_data=user_data? JSON.parse(this.krypto.decrypt(user_data)):null;

      } catch (error) {
        user_data=null;
      }
    }
    return user_data;
  }

  //onChasisChange
  checkChasis(payload: any){
    return this.http.post(this.activeUrl + "/general/search_chassis", payload);
  }

 //login api
  webLogin(payload:any){
    return this.http.post(this.activeUrl + "/general/sign_in", payload);
  }


  //change pin/password
  changePin(payload: any){
    return this.http.post(this.activeUrl + "/general/change_pin", payload);
  }

  changePinBrokerUser(payload: any){
    return this.http.post(this.activeUrl + "/brokeruser/change_pin", payload);
  }

  changePinBrokerAdmin(payload: any){
    return this.http.post(this.activeUrl + "/v2/brokeradmin/change_pin", payload);
  }

  //reset pin/password
  resetPin(payload: any){
    return this.http.post(this.activeUrl + "/general/request_pin_reset", payload);
  }

  //reset pin/password broker
  resetPinBroker(payload: any){
      return this.http.post(this.activeUrl + "/brokeruser/request_reset", payload);
  }
  


  //answer security questions
   answerSecurityQuestions(payload: any){
    return this.http.post(this.activeUrl + "/general/reset_pin", payload);
   }

  //answer security questions broker user
  answerSecurityQuestionsBroker(payload: any){
      return this.http.post(this.activeUrl + "/brokeruser/reset_pin", payload);
  }


   //create quote api
   creatQuote(payload:any){
    return this.http.post(this.baseURL2 + "webApp/add_quotes", payload);
   }


  // all policies created by agent api
  getAgentPolicies(agent_id:any){
    return this.http.post(this.baseURL + "get_policies", JSON.stringify({agent_id: agent_id}));//agent policies
   }


  // all stickers sold by agent api
  getAgentStickers(agent_id:any){
    return this.http.post(this.baseURL + "get_stickers", JSON.stringify({agent_id: agent_id}));//agent policies
   }

  // all total and daily production amount
  getAnaytics(payload){
    return this.http.post(this.activeUrl+'/transactions/get_transactions_analytics',payload);//analytics
  }
  // covers
  getCovers(){
    return this.http.post(this.activeUrl+'/general/retrieve_products',{policy_lob:"50"});//analytics
  }

  // fire items
  getFireItems(policy_sequence){
    return this.http.post(this.activeUrl+'/general/get_quotes_items',{policy_sequence:policy_sequence});//analytics
  }
  // fire legacy items
  getFireLegacyItems(payload){
    return this.http.post(this.activeUrl+'/general/get_quotes_items_legacy',payload);
  }


  // products
  getProducts(paylod){
    return this.http.post(this.activeUrl+'/general/retrieve_products',paylod);//analytics
  }

  // Occupation
  getOccupation(){
    return this.http.post(this.activeUrl+'/general/retrieve_profession',{policy_lob:"50"});//analytics
  }

  // for Cash inflow, cheque, mobile money
Cashsegregate(payload){
  return this.http.post(this.activeUrl+'/transactions/get_transactions_total_type',payload);
 }

 //transaction graph
gettransactionDetails(data){
  return this.http.post(this.activeUrl +'/transactions/get_transactions_Period_Details',data)
}

//print sticker
printSticker(payload){
  //return this.http.post(this.activeUrl +'/general/print_docs',payload);
  return this.http.post(this.activeUrl +'/v2/policy/print_doc',payload);
}

// sticker sales analytics
getStickersalesgraph(data){
  return this.http.post(this.activeUrl +'/transactions/get_stickerOverPeriod',data)
  }

// get list of banks
getBanksList(){
  return this.http.post(this.activeUrl +'/general/retrieve_banks',{})
}

//Cash Pay api
CashPay(payload){
      return this.http.post(this.baseURL + "/add_insurance", payload);
}


//Momo Pay api
DigiPay(payload:any){
  return this.http.post(this.FlutterPayURL,payload,this.flutterOptions);
}

//load policies api
LoadPolicies(payload:any){
  return this.http.post(this.baseURL2 + "clients/verify_policy", payload);
}

//submit new claim api
NewClaim(formData){
  return this.http.post(this.baseURL2 + "clients/initiate_claim", formData);
}

// get user transactions
getTransaction(payload){
  return this.http.post(this.activeUrl +'/transactions/get_transactions_nic',(payload));
 }


 sendOtp(payload){
   return this.http.post(this.activeUrl+'/general/request_OTP',payload);
 }

 getPolicyInfo(payload,flow='all'){
   return this.http.post(this.activeUrl+(flow=='today'?'/policy/get_policy_info_temp':'/policy/get_policy_info'),payload);
  //  return this.http.post(this.activeUrl+'/v2/policy/get_policy_info_temp',(payload));
 }

 getPoliciesForRenewal(payload){
  return this.http.post(this.activeUrl+'/policy/get_policies',(payload));
}

 //lookup a customer's renewable policies by phoneNumber, email or idNumber
 getRenewablePolicies(payload: { phoneNumber?: string; email?: string; idNumber?: string }){
  return this.http.post(this.activeUrl+'/policy/renewal/get_policies',(payload));
}

 //get the policies for document printing
 getPoliciesForDocuments(payload){
   //return this.http.post(this.activeUrl+'/general/info_for_print',payload);
   return this.http.post(this.activeUrl+'/policy/info_for_print',payload);
 }

 //get all quotes here
  getquote(payload){
    return this.http.post(this.activeUrl+'/quotes/get_quotes',(payload));
    //return this.http.post(this.activeUrl+'/general/get_quotes',(payload));
   }


// all customers api
  //  getCustomers(email, role){
  //   return this.http.post(this.live_Url+'/managers/get_clients',JSON.stringify({email: email, role:role}));//customers
  //  }


  //  new Customers
  // newClient(email, role){
  //   return this.http.post(this.live_Url+'/managers/get_newClients',({email:email, role:role}))
  // }

  getNotifications(id){
    return this.http.post(this.live_Url+'/agents/get_notifications',({id:id}))
  }

  // Send notifications
  sendNotification(data:any){
    return this.http.post(this.notifyUrl,data,this.smsoptions)
  }

  // Send Notifications
  sendSmstoDb(data){
    console.log(data);

    return this.http.post(this.live_Url+'/managers/add_notification',data)
  }




// top performing agents
getTopPerformingAgent(data:any){
  return this.http.post(this.live_Url+ '/managers/get_topPerformingAgents',data)
}

  // policy sales graph
  policiesGraphapi(data){
    return this.http.post(this.live_Url+'/managers/get_PolicyOverPeriod', data)
  }
  // claims sections
  claimProcess(email, role){
    return this.http.post(this.live_Url+'/claims/get_claims',({email:email, role:role}))
    }
// reister managers
addManager (mdata){
  console.log(mdata);
  return this.http.post(this.MailSender_Url+'/managers/add',mdata)

}

// get all managers
getManagers(email:any, role){
  return this.http.post(this.live_Url+'/get_managers',JSON.stringify({email:email, role:role}))
}

// get all countries
getCountries(){
  return this.http.post(this.activeUrl+'/general/retrieve_countries',{policy_lob:"50"})
}

// get all stickers here
getAllstickers(email:any, role){
return this.http.post(this.live_Url+'/managers/get_stickers',JSON.stringify({email:email, role:role}));
}

  // get all policies listings
getAllpolicies(email:any, role){
  return this.http.post(this.live_Url+'/managers/get_policies',JSON.stringify({email:email, role:role}));
}


  //  Search Customer
  searchCustomer(payload:any){
    return this.http.post(this.activeUrl+'/agents/search_customers', payload)

  }
  //  Search Make (legacy internal API – kept for reference)
  searchMake(agent_code, search_parameter,customer_code){
    return this.http.post(this.activeUrl+'/general/search_make_model',({agent_code:agent_code, make:search_parameter,client_code:customer_code,activity:"make",module:"client"}))
  }
  //  Search Model (legacy internal API – kept for reference)
  searchModel(agent_code,make_code ,search_parameter,customer_code){
    return this.http.post(this.activeUrl+'/general/search_make_model',({agent_code:agent_code,make:"", make_code:make_code,model:search_parameter,client_code:customer_code,activity:"model",module:"client"}))
  }

  // ── NHTSA Vehicle APIs ───────────────────────────────────────────────────────

  /** Fetch all vehicle makes from the NHTSA vPIC API */
  getAllVehicleMakes() {
    return this.http.get<{Count: number; Message: string; Results: {Make_ID: number; Make_Name: string}[]}>(
      'https://vpic.nhtsa.dot.gov/api/vehicles/GetAllMakes?format=json'
    );
  }

  /** Fetch all models for a given make name from the NHTSA vPIC API */
  getVehicleModelsForMake(makeName: string) {
    const encoded = encodeURIComponent(makeName);
    return this.http.get<{Count: number; Message: string; Results: {Make_ID: number; Make_Name: string; Model_ID: number; Model_Name: string}[]}>(
      `https://vpic.nhtsa.dot.gov/api/vehicles/GetModelsForMake/${encoded}?format=json`
    );
  }
  //  Get all vehicle colors
  getColors() {
    return this.http.get(this.activeUrl + '/vehicle-color?page=0&size=1000');
  }

  //get all the schedules/risks
  getSchedulesAndRisks(){
    return this.http.get(this.activeUrl + '/vehicle-risk?page=0&size=1000&enabled=true');
  }

  //construction types-staging
  getConstructionTypes(){
    return this.http.post(this.activeUrl+'/general/retrieve_construction_types',({}))
  }

  //get currencies
  getCurrencies(page: number = 0, size: number = 10){
    return this.http.get(this.activeUrl+`/currency?page=${page}&size=${size}`)
  }
  //get body types
  getBodyTypes(){
    return this.http.get(this.activeUrl + '/vehicle-body-type?page=0&size=1000');
  }

  //submit Moto Quote
  submitMotoQuote(payload :any){
    return this.http.post(this.activeUrl+'/general/add_quote',(payload))
  }

  //create quote
  createQuote(payload :any){
    return this.http.post(this.activeUrl+'/quotes/create',(payload))
  }

  //add vehicle
  addVehicle(payload :any){
      return this.http.post(this.activeUrl+'/quotes/update',(payload))
  }

  //add vehicle
  editVehicle(payload :any){
    return this.http.post(this.activeUrl+'/quotes/update',(payload))
}

  //add vehicle
  deleteVehicle(payload :any){
    return this.http.post(this.activeUrl+'/quotes/delete',(payload))
}


  //submit Fire Quote
  submitFireQuote(payload :any){
    return this.http.post(this.activeUrl+'/general/add_quote',(payload))
  }
  //submit Travel Quote
  submitTravelQuote(payload :any){
    return this.http.post(this.activeUrl+'/general/add_quote',(payload))
  }

  //submit payment
  subPayment(payload: any){
    if(payload.policy_lob == '20' && payload.transaction_type == 'MobileMoney'){
      return this.http.post(this.activeUrl+'/transactions/motor/digital',(payload))
   
    } if(payload.policy_lob == '20' && payload.transaction_type == 'Card'){
      return this.http.post(this.activeUrl+'/transactions/motor/digital',(payload))
    
    } else if(payload.policy_lob == '20' && payload.transaction_type == 'Cash'){
      return this.http.post(this.activeUrl+'/transactions/motor/cash',(payload))

    }else if(payload.policy_lob == '20' && payload.transaction_type == 'Cheque'){
      return this.http.post(this.activeUrl+'/transactions/motor/cheque',(payload))
    }
    else{
      let endpoint=''
      if(payload.hasOwnProperty('transaction_type') && payload.transaction_type=='MobileMoney')
      endpoint='/add_insurance_momo'
      else if(payload.transaction_type=='Card')
      endpoint='/add_insurance_momo_vang'
      else
      endpoint='/agents/add_insurance'
      return this.http.post(this.activeUrl+endpoint,(payload))
    }

  }

  digitalPayment(payload: any){
    return this.http.post(this.activeUrl+'/transactions/motor/digital',(payload))
  }

  cashPayment(payload: any){
    return this.http.post(this.activeUrl+'/transactions/motor/cash',(payload))
  }

  chequePayment(payload: any){
    return this.http.post(this.activeUrl+'/transactions/motor/cheque',(payload))
  }


  //Query Momo payment
  subQueryMomoPayment(payload: any){
    return this.http.post(this.activeUrl+'/manual_query',(payload))
  }

  manualQuery(payload: any){
    if(payload.policy_lob == '20'){
      return this.http.post(this.activeUrl+'/transactions/motor/manual_query',(payload))
    }else{
      return this.http.post(this.activeUrl+'/manual_query',(payload))
    }
   
  }

  //formating
  strDateToDBFormat(date :string){
       if(date){
        let dateParts=date.split("/");
        if(dateParts.length>1)
        return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
       }
       return null;

  }
  dateToDBFormat(date :Date){
    let date1= new Date(date);
    return `${date1.getFullYear()}-${(date1.getMonth()+1)}-${date1.getDate()}`;
  }
   // Customer sign up api
   customerSignUp(payload:any){
    return this.http.post(this.activeUrl + "/clients/create_account", payload);
  }
   agentCustomerSignUp(payload:any){
    return this.http.post(this.activeUrl + "/clients/create_account", payload);
  }

  verifyAgentAccount(payload){
    return this.http.post(this.activeUrl+'/agents/agent_verify',payload);
  }

  validateOTP(payload){
    return this.http.post(this.activeUrl+'/general/validate_OTP',payload);
  }

  agentAddSecurityQuestions(payload){
    return this.http.post(this.activeUrl+'/agents/add_security_answers',payload);
  }

  clientAddSecurityQuestions(payload) {
    return this.http.post(this.activeUrl + '/clients/add_security_answers', payload);
  }

  brokerAddSecurityQuestions(payload) {
    return this.http.post(this.activeUrl + '/brokeruser/add_security_answers', payload);
  }

  brokerAdminAddSecurityQuestions(payload) {
    return this.http.post(this.activeUrl + '/v2/brokeradmin/add_security_answers', payload);
  }

  agentUpdatePin(payload){
    return this.http.post(this.activeUrl+'/agents/update_pin',payload);
  }

  activateCustomer(payload){
    return this.http.post(this.activeUrl+'/clients/activate_account',payload);
  }

  webLoginAsBrokerUser(payload){
    return this.http.post(this.activeUrl+'/brokeruser/login',payload);
  }

  webLoginAsBrokerAdmin(payload){
    return this.http.post(this.activeUrl+'/v2/brokeradmin/login',payload);
  }

  cancelTravelPolicy(payload:any){
    return this.http.post(this.activeUrl + "/v2/policy/travel/cancel", payload);
  }

  updateTravelPolicy(payload:any){
    return this.http.post(this.activeUrl + "/v2/policy/travel/update", payload);
  }

  holdPolicy(payload:any){
    return this.http.post(this.activeUrl + "/v2/policy/travel/put_on_hold", payload);
  }

  reactivatePolicy(payload:any){
    return this.http.post(this.activeUrl + "/v2/policy/travel/enable_policy", payload);
  }

  extendPolicy(payload:any){
    return this.http.post(this.activeUrl + "/v2/policy/travel/extend_policy", payload);
  }

  reducePolicy(payload:any){
    return this.http.post(this.activeUrl + "/v2/policy/travel/reduce_policy", payload);
  }

  cancelPolicy(payload:any){
    return this.http.post(this.activeUrl + "/policy/cancel-policy", payload);
  }


    exportToExcel(payload){


    // let queryParams = new HttpParams({ fromObject: payload }); 
   

    // console.log("queryParams"+queryParams)

  
   // return this.http.get(this.base_Url + '/report/create?'+queryParams, { responseType: 'blob' as 'blob'   })

   // return this.http.post(this.base_Url + '/report/create', payload , { responseType: 'blob' as 'blob'   })



    // Content-Type and Authorization injected by ApiHeadersInterceptor.
    return this.http.post(this.activeUrl + '/report/create', payload, { responseType: 'blob' as 'blob' });
  }

    getBranches() {
    return this.http.post(this.activeUrl + '/general/retrieve_branches', ({}))
  }


  getAllAgents() {
    return this.http.post(this.activeUrl + '/agents/all_agents', ({}))
  }

  getBrokerUsers(payload) {
    return this.http.post(this.activeUrl + '/brokeruser/get_by_agent_code', payload)
  }

  GetPaymentPlatform(payload){
    return this.http.post(this.activeUrl+'/v2/payment_company/all',payload);
   }

   sendOTP(payload:any){
    return this.http.post(this.activeUrl + "/v2/otp/sendOtp", payload);
  }

  verifyOTP(payload:any){
    return this.http.post(this.activeUrl + "/v2/otp/verifyOtp", payload);
  }




  getUserLatLng() {
    localStorage.setItem('googleAPI', 'googleAPI')
    return this.http.post<any>(this.googleGeoLocURL + '?key=' + this.googleKey, {});
    
  }

  getUserCountryCode(lat: string,lng: string) {

    console.log("In code get service block")
    let resultType = 'country';

    localStorage.setItem('googleAPI', 'googleAPI')
    return this.http.get(this.googleGeoCodeURL +'?latlng='+lat+ ','+ lng +'&key=' + this.googleKey + '&' + 'result_type='+ resultType)
    
    
  }

















  //validations
   validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
   }
   validatePhone(phone){
     if(phone && !isNaN(+`${phone.trim()}`) && phone.trim().length==10 && phone.startsWith('0'))
      return true
    else
      return false;
   }

   validateGhanaCard(cardNumber){
     if (!cardNumber) return false;
     // Ghana Card pattern: <3 letters>-<9 digits>-<1 letter or digit>, e.g. GHA-712438385-1, USA-712438385-R
     const ghanaCardRegex = /^[A-Z]{3}-\d{9}-[A-Z0-9]$/i;
     return ghanaCardRegex.test(cardNumber.trim());
   }

   isValidatePin(pin){
     let regEx= new RegExp('^(?!(\\d)\\1+$|(?:0(?=1)|1(?=2)|2(?=3)|3(?=4)|4(?=5)|5(?=6)|6(?=7)|7(?=8)|8(?=9)|9(?=0)){5}\\d$|(?:0(?=9)|1(?=0)|2(?=1)|3(?=2)|4(?=3)|5(?=4)|6(?=5)|7(?=6)|8(?=7)|9(?=8)){5}\\d$)\\d{6}$');
      return regEx.test(pin);
   }

  strPadLeft(number, length) {

    var str = '' + number;
    while (str.length < length) {
        str = '0' + str;
    }

    return str;
  }
}
